import { SettingsApiTypes } from "@rshbintech.dboul/http";

export const getSetting = (
  settings: SettingsApiTypes.ClientSettings["settings"] | null,
  key: string,
  groupKey: string,
  systemId?: string
) => {
  const setting = settings?.[groupKey]?.find(
    (setting) =>
      setting.key === key &&
      (systemId && setting.systemId ? systemId === setting.systemId : true)
  );

  if (!setting) {
    throw new Error(
      `Настройка группы "${groupKey}" по ключу "${key}" не найдена.`
    );
  }

  const { value, defaultValue } = setting;

  return value ? value : defaultValue;
};
